<template>
	<v-layout row wrap>
		<v-flex sm12 md6>
			<p class="add-event-step-header">Event Restrictions</p>
			<v-checkbox v-model="everyone" label="Open to Everyone" hide-details class="add-event-radio-selection-small"></v-checkbox>
			<choice-field-input 
				:selectionOptions="getOptions"
				:storeSelections="getAddEventProp('restrictionInfo')"
				:storeInputs="getAddEventProp('restrictionInfoInputs')"
				selectionProp="restrictionInfo"
				selectionInputProp="restrictionInfoInputs"
				:mutation="getMutation">
			</choice-field-input>
			<v-radio-group v-model="approvalOption">
				<div class="p-relative mb-3">
					<v-radio value="instant_book" class="add-event-radio-selection-small" style="min-width: 50px!important; width: 50px!important;">
					</v-radio>
					<div class="add-event-radio-selection-small-title p-absolute" style="cursor: pointer" @click="approvalOption = 'instant_book'">
						Instant booking for all guests (recommended)
					</div>
					<div class="mt-3 add-event-radio-selection-small-subtitle">
						All WRKPRTY Members can RSVP for this event if they meet event requirements (age, interests, etc.). This option is recommended because it simplifies things for you, the host, and may increase the number of attendees.
					</div>
				</div>
				<div class="p-relative mb-3">
					<v-radio value="level_one" class="add-event-radio-selection-small">
					</v-radio>
					<div class="add-event-radio-selection-small-title p-absolute" style="cursor: pointer" @click="approvalOption = 'level_one'">
						Instant booking for special guests.
					</div>
					<div class="mt-3 add-event-radio-selection-small-subtitle">
						Members that have already attended 1 or more WRKPRTY's and have received zero negative reviews will be instantly approved for your event. New users must be approved.
					</div>
				</div>
				<div class="p-relative mb-3">
					<v-radio value="all_need_approval" class="add-event-radio-selection-small">
					</v-radio>
					<div class="add-event-radio-selection-small-title p-absolute" style="cursor: pointer" @click="approvalOption = 'all_need_approval'">
						Instant booking off
					</div>
					<div class="mt-3 add-event-radio-selection-small-subtitle">
						All RSVP requests must be approved by Host. Note: This option provides host with total control over attendee list, but requires the Host to promptly approve requests when they are made. Please also note WRKPRTY's discrimination policy: any indication of discrimination in approving guests on the basis of race or other factors, will result in termination of your hosting account.
					</div>
				</div>
			</v-radio-group>
		</v-flex>
		<v-flex md4 offset-md1 hidden-sm-and-down>
			<v-card class="add-event-tip-box">
				<v-card-text class="p-relative pt-5">
					<div class="info-trapezoid p-absolute">
						<div class="info-content">
							<img src="/static/images/icon/light-bulb-gray.svg" width="40" />
						</div>
					</div>
					<p class="add-event-tip-title">Customize the guests’ experience</p>
					<p class="add-event-tip-content">We understand some events are designed to bring together groups of people with shared interests or other common factors.</p>
					<p class="add-event-tip-content">In some cases, creating your event for specific occupations or groups can event help people connect with each other in more meaningful ways.</p>
					<p class="add-event-tip-title">Be inclusive</p>
					<p class="add-event-tip-content">Remember, building a vibrant community is about connecting people together who don’t often interact.</p>
					<p class="add-event-tip-content">Unless doing so is important to the nature of your event (e.g. you are creating an event for parents and their young children), we encourage you to use restrictions as little as possible.</p>
				</v-card-text>
			</v-card>
		</v-flex>
		<v-dialog scrollable v-model="infoDialog">
			<v-card style="width: 100%">
				<v-card-title class="mb-0 pb-2 pt-3">
					<img class="info-mobile-icon" src="/static/images/icon/light-bulb-gray.svg" />
				</v-card-title>
				<v-card-text style="max-height:50vh;">
					<p class="add-event-tip-title">Customize the guests’ experience</p>
					<p class="add-event-tip-content">We understand some events are designed to bring together groups of people with shared interests or other common factors.</p>
					<p class="add-event-tip-content">In some cases, creating your event for specific occupations or groups can event help people connect with each other in more meaningful ways.</p>
					<p class="add-event-tip-title">Be inclusive</p>
					<p class="add-event-tip-content">Remember, building a vibrant community is about connecting people together who don’t often interact.</p>
					<p class="add-event-tip-content">Unless doing so is important to the nature of your event (e.g. you are creating an event for parents and their young children), we encourage you to use restrictions as little as possible.</p>
				</v-card-text>
				<v-card-actions>
					<v-spacer>
					</v-spacer>
					<v-btn icon class="info-mobile-dialog-close-button" @click="infoDialog=false"><v-icon>close</v-icon></v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-layout>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { eventRestrictionOptions } from '~/store/util/values'
import { deepCopy } from '~/store/util/util'
import * as TYPE from '~/store/util/types'
import ChoiceFieldInput from '~/components/ChoiceFieldInput'
export default {
	data() {
		return {
			restrictionOptions: eventRestrictionOptions,
			every: true,
			restrictionInfo: [],
			restrictionInfoInputs: {},
			rules: {
				ageMin: value => {
					if (value >= 0 && value <= 100) {
						return true
					}
					return 'Age must be a number between 0 and 100'
				},
				ageMax: value => {
					if (value >= 0 && value <= 100) {
						return true
					}
					return 'Age must be a number between 0 and 100'
				}
			}
		}
	},
	components: {
		ChoiceFieldInput: ChoiceFieldInput
	},
	beforeRouteLeave(to, from, next) {
		this.setAddEventValidStep(from.path)
		this.removeAddEventInvalidStep(from.path)
		next()
	},
	methods: {
		...mapActions(['setAddEventProp', 'setAddEventValidStep', 'removeAddEventInvalidStep']),
		setOpenToAll(val) {
			if (val) {
				this.setAddEventProp({ prop: 'restrictionsWomenOnly', value: false })
			}
		},
		updateRestrictionInfo() {
			this.$store.commit(TYPE.SET_ADD_EVENT_PROP, {
				prop: 'restrictionInfo',
				value: this.restrictionInfo
			})
		},
		updateRestrictionInfoInput(key) {
			this.restrictionInfoInputs[key] = document.getElementById(key).value
			this.$store.commit(TYPE.SET_ADD_EVENT_PROP, {
				prop: 'restrictionInfoInputs',
				value: this.restrictionInfoInputs
			})
		},
		updateRestrictionInfoRadioInput(key, radioVal) {
			this.restrictionInfoInputs[key] = document.getElementById(radioVal).value
			this.$store.commit(TYPE.SET_ADD_EVENT_PROP, {
				prop: 'restrictionInfoInputs',
				value: this.restrictionInfoInputs
			})
		},
		isSelected(value) {
			if (this.restrictionInfo.includes(value.value)) {
				return true
			} else {
				if (value.type) {
					if (value.type.includes('header')) {
						return true
					}
				}
			}
		},
		getInputVal(key) {
			if (this.restrictionInfoInputs.hasOwnProperty(key)) {
				return this.restrictionInfoInputs[key]
			}
		}
	},
	mounted() {
		if (this.getAddEventProp('restrictionInfo') !== []) {
			this.restrictionInfo = this.getAddEventProp('restrictionInfo')
		}
		if (this.getAddEventProp('restrictionInfoInputs') !== []) {
			this.restrictionInfoInputs = this.getAddEventProp('restrictionInfoInputs')
		}
	},
	computed: {
		...mapGetters(['getAddEventProp']),
		getMutation() {
			return TYPE.SET_ADD_EVENT_PROP
		},
		getOptions() {
			return eventRestrictionOptions
		},
		approvalOption: {
			get() {
				return this.getAddEventProp('approvalOption')
			},
			set(val) {
				this.setAddEventProp({ prop: 'approvalOption', value: val })
			}
		},
		everyone: {
			get() {
				let temp = deepCopy(this.getAddEventProp('restrictionInfo'))
				let ar = temp.map(val => val)
				let open = JSON.stringify(ar) === JSON.stringify(new Array('everyone'))
				if (open === false) {
					if (temp.indexOf('everyone') !== -1) {
						temp.splice(temp.indexOf('everyone'), 1)
					}
				}
				this.setAddEventProp({ prop: 'restrictionInfo', value: temp })
				return open
			},
			set(val) {
				this.every = val
				if (val === true) {
					this.setAddEventProp({
						prop: 'restrictionInfo',
						value: ['everyone']
					})
				}
			}
		},
		infoDialog: {
			get() {
				return this.getAddEventProp('infoDialog')
			},
			set(val) {
				this.setAddEventProp({ prop: 'infoDialog', value: val })
			}
		},
		restrictionInfoComputed: {
			get() {
				return this.restrictionInfo
			},
			set(val) {
				this.restrictionInfo = val
			}
		}
	}
}
</script>

<style>
</style>
